<div class="d-flex ion-align-items-center gap-1">
    <div class="d-flex ion-align-items-center">
        <ion-icon [class]="'label-state-' + type"
                  style="transform: scale(1.1)"
                  name="ellipse"></ion-icon>
    </div>
    <div class="d-flex ion-align-items-center">
        <span class=" ">{{label}}</span>
    </div>
</div>
